<template>
  <section class="landing-section">
    <b-container class="h-100">
      <div class="landing-wrapper">
        <div class="content">
          <div class="border-vertical"></div>
          <div>
            <h4>The Coinaholic For Everyone</h4>
            <h5>Explore All Courses Here</h5>
          </div>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "LandingSection",
};
</script>

<style lang="scss" scoped>
.landing-section {
  background: #024089 url("../../assets/img/landing.svg");
  background-repeat: no-repeat;
  height: calc(100vh - 38px);

  @media (min-width: 1400px) {
    height: 764px;
  }
  width: 100%;

  .landing-wrapper {
    height: 100%;
    width: 100%;
    background: url("../../assets/img/bitcoin-boy.svg");
    background-repeat: no-repeat;
    background-position: right 70%;
    background-size: 500px auto;
    display: flex;
    align-items: center;

    .content {
      display: flex;
      gap: 12px;

      .border-vertical {
        background: #ffffff;
        width: 3px;
        height: 70px;
        margin: auto;
        top: 2px;
        position: relative;
      }
      h4 {
        color: #f1bc04;
        font-size: 45px;
        line-height: 53px;
        letter-spacing: 0.05em;
      }
      h5 {
        color: #ffffff;
        font-size: 25px;
        padding-left: 8px;
        line-height: 29px;
        letter-spacing: 0.05em;
      }
    }
  }
}
</style>
